import { useQuery, skipToken, keepPreviousData } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  DashboardSummaryParams,
  getDashboardTransactionsSuccessSummary,
} from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsSuccessSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

export function useGetDashboardTransactionsSuccessSummary(params: DashboardSummaryParams | null) {
  const translate = useTypedTranslate();

  const normalizedParams = params
    ? {
        periodFrom: params.periodFrom,
        periodTo: params.periodTo,
        timezone: params.timezone,
        merchant: params.merchant,
        provider: params.provider,
        gateway: params.gateway,
      }
    : null;

  const {
    data: summary,
    isFetching,
    isLoading,
    error,
  } = useQuery<TransactionsSuccessSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/transaction_success_summary', normalizedParams],
    queryFn: normalizedParams
      ? () => getDashboardTransactionsSuccessSummary(normalizedParams)
      : skipToken,
    placeholderData: keepPreviousData,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isFetching, isLoading, error: errorMessage };
}

export type GetDashboardTransactionsSuccessSummaryResult = ReturnType<
  typeof useGetDashboardTransactionsSuccessSummary
>;
